import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPiechart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.85785 3.00176L8.37863 7.2876C8.46509 7.53127 8.64258 7.73199 8.87384 7.84762L12.9412 9.88127M6.85785 3.00176C7.37549 2.81808 7.93277 2.71809 8.51339 2.71809C11.2468 2.71809 13.4627 4.93397 13.4627 7.66739C13.4627 8.46319 13.2749 9.21512 12.9412 9.88127M6.85785 3.00176L6.72917 2.63913C6.54448 2.11863 5.96746 1.8398 5.48271 2.10446C3.51472 3.1789 2.17969 5.26723 2.17969 7.66737C2.17969 11.1654 5.01539 14.0011 8.51341 14.0011C10.6351 14.0011 12.5132 12.9578 13.6626 11.3563C13.9848 10.9073 13.7788 10.3001 13.2846 10.053L12.9412 9.88127",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgPiechart);
export default ForwardRef;
